import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const savingsDataFragment = gql`
  fragment savingsData on UserRedemptionReportSavingsData {
    value
    currency
    breakdown {
      value
      currency
      type
    }
  }
`

const query = gql`
  query UserSavings(
    $month: RedemptionReportDateMessageInput
    $duration: RedemptionReportDuration
    $limit: Int
  ) {
    userSavings(month: $month, duration: $duration, limit: $limit) {
      previousSavings {
        total {
          value
          currency
        }
      }
      savings {
        total {
          value
          currency
        }
        fixed {
          ...savingsData
        }
        estimated {
          ...savingsData
        }
      }
      report {
        perks {
          redemptions
          uniqueUsers
          type
          savingsPercentage
          brandName
          header
          totalSavings {
            currency
            value
          }
        }
      }
    }
  }
  ${savingsDataFragment}
`

export const userSavingsKey = getQueryNames(query)[0]

export default query
